module.exports = __webpack_public_path__ + "img/target.df7999a3.jpg";